<template>
  <div>
    <div class="row q-mb-lg">
      <div class="col-5 text-h4">Счета и акты</div>
      <div class="col-7">
        <q-btn
          no-caps
          label="Удалить счёт"
          v-bind:disable="!billsnotpayed"
          color="white"
          flat
          @click.prevent="deleteBill()"
          class="float-right q-ml-md"
        ></q-btn>
        <q-btn
          :loading="billcreateprogress"
          color="secondary"
          class="float-right createbillbtn"
          unelevated
          no-caps
          @click.prevent="
            billcreateprogress = true;
            createBill();
          "
        >
          Создать счёт
          <template v-slot:loading>
            <q-spinner-hourglass class="on-left" />Счёт формируется..
          </template>
        </q-btn>
      </div>
    </div>

    <q-table
      dark
      class="no-border"
      table-class="bg-primary-light"
      table-header-class="boldheader"
      :pagination="{ rowsPerPage: 10 }"
      flat
      dense
      hide-bottom
      bordered
      :data="bills"
      :columns="billcolumns"
      row-key="billid"
      separator="cell"
      square
      v-if="bills != ''"
    >
      <template v-slot:body="props">
        <q-tr :props="props">
          <!-- Счёт -->
          <q-td key="billnumber" :props="props" class="q-pa-sm">
            <div>{{ props.row.billnumber + " от " + props.row.billdate }}</div>
            <div class="q-mt-xs text-caption" style="opacity: 0.6">
              Распечатать:
              <a
                class="print-link"
                @click.prevent="
                  printDoc({
                    doctype: 'bill',
                    number: props.row.billnumber,
                    date: props.row.billdate
                  })
                "
                >счёт</a
              ><template v-if="props.row.sfstatus > 0"
                >,
                <a
                  v-if="props.row.edo_html_link"
                  class="print-link"
                  :href="props.row.edo_html_link"
                  target="_blank"
                  >акт</a
                ><a
                  v-else
                  class="print-link"
                  @click.prevent="
                    printDoc({
                      doctype: 'act',
                      number: props.row.sfnumber,
                      date: props.row.sfdate
                    })
                  "
                  >акт</a
                ></template
              >
            </div>
          </q-td>

          <!-- Оплата -->
          <q-td key="payment" :props="props" class="text-center">
            <template v-if="props.row.billpayedpp > 0">
              <q-icon
                name="description"
                color="accent"
                size="xs"
                style="cursor:default"
              >
                <q-tooltip
                  anchor="top middle"
                  self="bottom middle"
                  :offset="[0, 4]"
                >
                  <div>№ {{ props.row.billpayedpp }}</div>
                  <div style="opacity:0.7">{{ props.row.billpayeddate }}</div>
                </q-tooltip>
              </q-icon>
            </template>
            <span v-else class="text-grey-5">—</span>
          </q-td>

          <!-- ЭДО -->
          <q-td style="padding-right: 8px" key="edo" :props="props">
            <template
              v-if="props.row.sfstatus > 0 && hasEdoRequisites(props.row)"
            >
              <div
                class="flex no-wrap items-end justify-between"
                style="width: 320px;"
              >
                <!-- Левый блок: название + идентификатор -->
                <div class="edo-left" style="width: 50%; padding-right: 16px">
                  <div class="edo-name ellipsis text-caption">
                    {{ companyName(props.row) }}
                  </div>
                  <div class="row no-wrap items-center no-wrap">
                    <template v-if="participantIdFor(props.row)">
                      <div class="edo-pid ellipsis text-caption text-mono col">
                        {{ participantIdFor(props.row) }}
                      </div>
                      <q-btn
                        flat
                        round
                        dense
                        size="xs"
                        icon="edit"
                        color="grey-4"
                        class="q-ml-xs flex-shrink-0"
                        @click="openParticipantModal(props.row)"
                      />
                    </template>
                    <template v-else>
                      <q-btn
                        flat
                        no-caps
                        dense
                        size="sm"
                        color="yellow-5"
                        label="Выбрать идентификатор ЭДО"
                        :loading="!!participantLoading[props.row.billid]"
                        @click="openParticipantModal(props.row)"
                      />
                    </template>
                  </div>
                </div>

                <!-- Правый блок: статус ЭДО -->
                <div
                  class="q-ml-sm flex-shrink-0 flex items-end justify-end"
                  style="width: calc(50% - 16px)"
                >
                  <template v-if="!edoStatus(props.row)">
                    <q-btn
                      class="q-px-xs"
                      unelevated
                      no-caps
                      dense
                      size="sm"
                      color="secondary"
                      label="Получить документ"
                      :loading="!!edoLoading[props.row.billid]"
                      :disable="!participantIdFor(props.row)"
                      @click="sendEdo(props.row.billid)"
                    />
                  </template>
                  <template v-else>
                    <q-chip
                      dense
                      :color="edoColor(edoStatus(props.row))"
                      text-color="white"
                      style="max-width:96px;font-size:12px"
                    >
                      <span class="ellipsis" style="max-width:96px">{{
                        edoLabel(edoStatus(props.row))
                      }}</span>
                    </q-chip>
                    <q-btn
                      flat
                      round
                      dense
                      size="sm"
                      icon="refresh"
                      color="grey-4"
                      :loading="!!edoLoading[props.row.billid]"
                      @click="checkEdoStatus(props.row.billid)"
                    />
                  </template>
                </div>
              </div>
            </template>
            <span v-else class="text-grey-5">—</span>
          </q-td>
        </q-tr>
      </template>
    </q-table>

    <p class="q-mt-lg">
      * Отчетные документы формируются в последний календарный день квартала
    </p>

    <!-- KPP input modal -->
    <q-dialog v-model="showKppModal" persistent>
      <q-card dark class="bg-primary-light participant-modal">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">КПП покупателя</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <div v-if="kppModalRow" class="text-caption text-grey-4 q-mb-md">
            {{ companyName(kppModalRow) }}
          </div>
          <q-input
            v-model="kppInput"
            dark
            filled
            color="yellow-5"
            dense
            label="КПП (9 цифр)"
            mask="#########"
            @keyup.enter="saveKppAndContinue"
          />
        </q-card-section>
        <q-card-actions class="q-pa-md q-pt-none">
          <q-btn
            unelevated
            no-caps
            color="secondary"
            label="Продолжить"
            class="full-width"
            :loading="kppSaving"
            :disable="kppInput.length !== 9"
            @click="saveKppAndContinue"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Participant ID selection modal -->
    <q-dialog v-model="showParticipantModal" persistent>
      <q-card dark class="bg-primary-light participant-modal">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6">Идентификатор ЭДО покупателя</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div v-if="counterpartyLoading" class="text-center q-py-md">
            <q-spinner size="md" color="secondary" />
          </div>
          <div
            v-else-if="counterpartyList.length === 0"
            class="text-grey-5 text-center q-py-md"
          >
            Идентификаторы не найдены
          </div>
          <q-list v-else separator>
            <q-item
              v-for="item in counterpartyList"
              :key="item.id"
              clickable
              :active="participantIdFor(participantModalRow) === item.id"
              active-color="secondary"
              @click="selectParticipant(item.id)"
            >
              <q-item-section>
                <q-item-label class="text-mono  text-white">{{
                  item.id
                }}</q-item-label>
                <q-item-label caption class="text-grey-5">
                  {{ item.operator
                  }}<span v-if="item.state"> · {{ item.state }}</span>
                </q-item-label>
              </q-item-section>
              <q-item-section side v-if="item.main">
                <q-badge color="positive" label="Основной" />
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import BillTemplate from "src/service/classes/printbill.js";
import ActTemplate from "src/service/classes/printact.js";
export default {
  data: function() {
    return {
      billcolumns: [
        {
          name: "billnumber",
          align: "left",
          label: "Счёт",
          style: "width:30%"
        },
        {
          name: "payment",
          align: "center",
          label: "Оплата",
          style: "width:20%"
        },
        { name: "edo", align: "left", label: "ЭДО", style: "width:50%" }
      ],
      billcreateprogress: false,
      edoLoading: {},
      edoStatuses: {},
      participantIds: {},
      participantLoading: {},
      showParticipantModal: false,
      participantModalRow: null,
      counterpartyList: [],
      counterpartyLoading: false,
      showKppModal: false,
      kppModalRow: null,
      kppInput: "",
      kppSaving: false
    };
  },
  computed: {
    bills() {
      return this.$store.getters.BILLS;
    },
    billsnotpayed() {
      let res = false;
      for (let i = 0; i < this.bills.length; i++) {
        if (this.bills[i].billpayed == 0) res = true;
      }
      return res;
    },
    browser() {
      return {
        name: this.$q.platform.is.name,
        version: this.$q.platform.is.versionNumber
      };
    }
  },
  methods: {
    async createBill() {
      try {
        if (this.$store.getters.ACCOUNT.req.companyname != "") {
          this.billcreateprogress = true;
          this.$store.dispatch("CREATE_BILL");
          await new Promise(resolve => setTimeout(resolve, 1500));
          this.billcreateprogress = false;
        } else {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: "Сначала необходимо заполнить реквизиты"
          });
        }
      } catch (err) {
        this.billcreateprogress = false;
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext:
            "Ошибка при создании счета. Информация передана разработчикам. Попробуйте позже"
        });
        this.$store.dispatch("LOG_ERROR", {
          error: err,
          desc: "createBill function"
        });
      }
    },
    deleteBill() {
      this.$store.dispatch("DELETE_BILL");
    },
    async printDoc(payload) {
      try {
        let data = await this.$store.dispatch("PRINT_DOC", payload);
        if (payload.doctype == "bill" && !data.error) {
          let bill = new BillTemplate();
          bill.CreateBill(data.body.req, data.body.qr);
          bill.print(this.browser);
        } else if (payload.doctype == "act" && !data.error) {
          let act = new ActTemplate();
          act.CreateAct(data.body.req, true);
          act.print(this.browser);
        }
      } catch (err) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext:
            "Ошибка при создании печатной формы документа. Информация передана разработчикам. Попробуйте позже"
        });
        this.$store.dispatch("LOG_ERROR", {
          error: err,
          desc: "printDoc function"
        });
      }
    },
    printLastBill() {
      this.printDoc({
        doctype: "bill",
        number: this.bills[this.bills.length - 1].billnumber,
        date: this.bills[this.bills.length - 1].billdate
      });
    },
    hasEdoRequisites(row) {
      try {
        const cr = JSON.parse(row.clientreq || "{}");
        return !!(
          cr.cinn &&
          cr.cname &&
          cr.cinn.replace(/\D/g, "").length === 10
        );
      } catch (_) {
        return false;
      }
    },
    companyName(row) {
      try {
        return JSON.parse(row.clientreq || "{}").cname || "";
      } catch (_) {
        return "";
      }
    },
    participantIdFor(row) {
      if (!row) return "";
      return this.participantIds[row.billid] !== undefined
        ? this.participantIds[row.billid]
        : row.edo_participant_id || "";
    },
    edoStatus(row) {
      return this.edoStatuses[row.billid] !== undefined
        ? this.edoStatuses[row.billid]
        : row.edo_status || "";
    },
    edoLabel(status) {
      const map = {
        draft: "Сформирован",
        pending: "Сформирован",
        sending: "Отправляется",
        sent: "Отправлен",
        delivered: "Доставлен",
        signed: "Подписан",
        rejected: "Отклонён",
        error: "Ошибка отправки"
      };
      return map[status] || status;
    },
    edoColor(status) {
      const map = {
        sending: "yellow-8",
        sent: "blue",
        delivered: "teal",
        signed: "positive",
        rejected: "negative",
        error: "negative"
      };
      return map[status] || "grey";
    },
    async openParticipantModal(row) {
      const cr = JSON.parse(row.clientreq || "{}");
      if (!cr.ckpp) {
        this.kppModalRow = row;
        this.kppInput = "";
        this.showKppModal = true;
        return;
      }
      this.participantModalRow = row;
      this.counterpartyList = [];
      this.showParticipantModal = true;
      this.counterpartyLoading = true;
      try {
        const res = await this.$api.post("/api/edo/", {
          action: "get_counterparty",
          inn: cr.cinn || "",
          kpp: cr.ckpp || ""
        });
        if (res.data.error) {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: res.data.errortext
          });
          this.showParticipantModal = false;
        } else {
          this.counterpartyList = res.data.body.identifiers || [];
        }
      } catch (_) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "Ошибка получения идентификаторов ЭДО"
        });
        this.showParticipantModal = false;
      }
      this.counterpartyLoading = false;
    },
    async saveKppAndContinue() {
      if (!/^\d{9}$/.test(this.kppInput)) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "КПП должен содержать ровно 9 цифр"
        });
        return;
      }
      this.kppSaving = true;
      try {
        const res = await this.$api.post("/api/edo/", {
          action: "save_kpp",
          billid: this.kppModalRow.billid,
          kpp: this.kppInput
        });
        if (res.data.error) {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: res.data.errortext
          });
        } else {
          const cr = JSON.parse(this.kppModalRow.clientreq || "{}");
          cr.ckpp = this.kppInput;
          this.kppModalRow.clientreq = JSON.stringify(cr);
          this.showKppModal = false;
          this.openParticipantModal(this.kppModalRow);
        }
      } catch (_) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "Ошибка сохранения КПП"
        });
      }
      this.kppSaving = false;
    },
    async selectParticipant(pid) {
      const row = this.participantModalRow;
      if (!row) return;
      this.$set(this.participantLoading, row.billid, true);
      this.showParticipantModal = false;
      try {
        const res = await this.$api.post("/api/edo/", {
          action: "save_participant_id",
          billid: row.billid,
          participant_id: pid
        });
        if (res.data.error) {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: res.data.errortext
          });
        } else {
          this.$set(this.participantIds, row.billid, pid);
        }
      } catch (_) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "Ошибка сохранения идентификатора ЭДО"
        });
      }
      this.$set(this.participantLoading, row.billid, false);
    },
    async sendEdo(billid) {
      this.$set(this.edoLoading, billid, true);
      try {
        const res = await this.$api.post("/api/edo/", {
          action: "send_act",
          billid
        });
        if (res.data.error) {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: res.data.errortext
          });
        } else {
          this.$set(this.edoStatuses, billid, res.data.body.edo_status);
          const row = (this.bills || []).find(b => b.billid === billid);
          if (row && res.data.body.edo_html_link) {
            this.$set(row, "edo_html_link", res.data.body.edo_html_link);
          }
        }
      } catch (_) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "Ошибка отправки в ЭДО"
        });
      }
      this.$set(this.edoLoading, billid, false);
    },
    async checkEdoStatus(billid) {
      this.$set(this.edoLoading, billid, true);
      try {
        const res = await this.$api.post("/api/edo/", {
          action: "check_status",
          billid
        });
        if (res.data.error) {
          this.$store.commit("SET_ERROR", {
            error: true,
            errortext: res.data.errortext
          });
        } else {
          this.$set(this.edoStatuses, billid, res.data.body.edo_status);
        }
      } catch (_) {
        this.$store.commit("SET_ERROR", {
          error: true,
          errortext: "Ошибка получения статуса ЭДО"
        });
      }
      this.$set(this.edoLoading, billid, false);
    }
  },
  mounted() {
    this.$eventBus.$on("print-last-bill", a => this.printLastBill(a));
  },
  beforeDestroy() {
    this.$eventBus.$off("print-last-bill");
  }
};
</script>

<style lang="sass">
.boldheader th
  font-weight: 700
  background: rgba(0,0,0,0.1)
.billtable>table
  border: 1px solid rgba(0, 0, 0, 0.3)
  table-layout: fixed
  width: 100%
.billtable>table th, .billtable>table td
  border-color: rgba(0,0,0,0.3)
.createbillbtn
  min-width: 180px
.text-mono
  font-family: monospace
.participant-modal
  min-width: 420px
.edo-left
  min-width: 0
.edo-name, .edo-pid
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  max-width: 100%
.print-link
  color: inherit
  text-decoration: underline
  cursor: pointer
  &:hover
    opacity: 0.75
</style>
